import { useState, useCallback } from 'react';
import { formatGovOpsError } from '../api/govopsErrors';
import { submitPermitIntake, formatIntakeSuccess } from '../utils/permitIntake';

/**
 * GOVOPS-1113 — shared submit state for all single-permit intake surfaces.
 */
export function usePermitIntake({ source, mode, onSuccess }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [lastResult, setLastResult] = useState(null);

  const clearMessages = useCallback(() => {
    setError('');
    setSuccess('');
  }, []);

  const submit = useCallback(
    async (form) => {
      setSubmitting(true);
      setError('');
      setSuccess('');
      try {
        const result = await submitPermitIntake(form, { source, mode });
        setLastResult(result);
        const msg = formatIntakeSuccess(result);
        setSuccess(msg);
        onSuccess?.(result);
        return result;
      } catch (err) {
        const message =
          err?.validationErrors?.join(' ') || formatGovOpsError(err) || err?.message || 'Submit failed';
        setError(message);
        throw err;
      } finally {
        setSubmitting(false);
      }
    },
    [source, mode, onSuccess]
  );

  return {
    submit,
    submitting,
    error,
    success,
    lastResult,
    clearMessages,
    setError,
    setSuccess,
  };
}
